import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { Router, RouterStateSnapshot } from "@angular/router";
import { Sort } from '@angular/material/sort';
import {PageEvent} from '@angular/material/paginator';

import { PaginationInstance } from '../../../../node_modules/ngx-pagination/dist/ngx-pagination.module';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar, } from '@angular/material';

import { DataService } from './../../data.service';
import { AppConfig } from './../../config';
import { MockupInput } from './../../mockup-input';


@Component({
  selector: 'app-applicationlist',
  templateUrl: './applicationlist.component.html',
  styleUrls: ['./applicationlist.component.scss']
})
export class ApplicationListComponent implements OnInit {


  @ViewChild(MatSort, { static: false }) set mscontent(ms: MatSort) {
    this.matSort = ms;
  }

  @ViewChild(MatPaginator, { static: false }) set mpcontent(mp: MatPaginator) {
    this.paginator = mp;
  }
  
  pageEvent: PageEvent;

  public paginationConfig: PaginationInstance = {
    id: 'advanced',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0
  };

  matSort: MatSort;
  paginator: MatPaginator;
  applicationList=[];
  displayedColumns: string[] = ['id', 'label', 'standard', 'description', 'active'];
  dataSource = new MatTableDataSource();

  appPageSizeOptions = this.appConfig.appPageSizeOptions;
  appDefaultPageSize = this.appConfig.appDefaultPageSize;

  isLoading = false;
  isError = false;
  errorMessage = "";

  sorting = {
    fieldName: 'createddate',
    order: 'ASC'
  }

  sortData(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === '') {
      return;
    }
    const isAsc = sort.direction.toLocaleUpperCase() === 'ASC';
    this.sorting.fieldName = sort.active;
    if (isAsc) {
      this.sorting.order = "ASC";
    }
    else {
      this.sorting.order = "DESC";
    }
    this.getApplicationList();

  }

  pageChanged(pe: PageEvent) {
    console.log("pageevent", pe);
    this.paginationConfig.itemsPerPage = pe.pageSize;
    this.paginationConfig.currentPage = pe.pageIndex + 1;
    this.getApplicationList();

  }
  constructor(private formBuilder: FormBuilder, private dataService: DataService, private mockupInput: MockupInput,
    private router: Router, public snackBar: MatSnackBar, private appConfig: AppConfig) { }

  ngOnInit() {

    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;

    this.paginationConfig.itemsPerPage = this.appDefaultPageSize;
    this.paginationConfig.currentPage = 1

    this.getApplicationList();
  }

  newApp()
  {
    this.router.navigateByUrl('/home/application/new');  
  }

  getApplicationList() {

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
      subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
      data: {
        pagination: true,
        pagenum: this.paginationConfig.currentPage,
        pagesize: this.paginationConfig.itemsPerPage,
        sortfield: this.sorting.fieldName,
        sortorder: this.sorting.order,
      }
    }

    this.isLoading = true;
    this.dataService.getApplications(postOption).subscribe(
      res => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          console.log("success");
          this.paginationConfig.totalItems = res.data.totalrows;
          this.applicationList = res.data.application;

          //assign table data will refresh it automatically
          this.dataSource.data = this.applicationList;
          this.matSort._stateChanges.next();



          this.isLoading = false;
        }
        else {
          console.log("No data");
          this.paginationConfig.itemsPerPage = 10
          this.paginationConfig.currentPage = 1
          this.paginationConfig.totalItems = 0

          this.isLoading = false;

        }
      },
      err => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );


  }

}
